import { v4 as uuidv4 } from "uuid";
import {ValidationRules} from "@/utils/validation-rules";
import {DocumentCategory} from "@/models/documents/DocumentCategory";
export default {
  name: "DocumentsCategoriesDlg",
  data() {
    return {
      dialog: false,
      loading: false,
      categoryName: '',
      allCategories: [],
      newCategories: [],
      removeCategories: [],
    }
  },
  computed: {
    categories() {
      return this.$store.state.documentsModule.documentsCategories;
    },
    categoryList(){
      return this.newCategories.concat(this.allCategories)
    },
    facility() {
      return this.$store.state.authModule.currentFacility;
    },
    user() {
      return this.$store.state.authModule.user;
    },
    rules() {
      return {
        categoryName: [ValidationRules.min(2), ValidationRules.max(70)],
      };
    },
  },
  mounted(){
    this.$store.dispatch("getDocumentsCategories")
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.newCategories = []
      this.removeCategories = []
      this.categoryName = ''
      this.loading = false
      this.dialog = false;
    },
    addCategory() {
      if(this.categoryName.length){
        this.newCategories.push({ id: uuidv4(), name: this.categoryName });
        this.categoryName = '';
      }
    },
    updateCategory(category){
      category.changed = true
      this.$forceUpdate();
    },
    removeCategory(category) {
      this.removeCategories.push(category);
      this.allCategories = this.allCategories.filter(x=>x.id !== category.id)
      this.newCategories = this.newCategories.filter(x=>x.id !== category.id)
    },
    saveCategories() {
      this.loading = true
      const promises = []

      if(this.newCategories.length){
        const promise = this.$store.dispatch(
          "addDocumentsCategories",
          this.newCategories.map((x)=> {
            delete x.id;
            return new DocumentCategory(x.name, this.facility, this.user.id, this.user.name);
          })
        )

        promises.push(promise)
      }

      if(this.removeCategories.length){
        const promise = this.$store.dispatch("deleteDocumentsCategories", {
          categories: this.removeCategories,
          facilityId: this.facility
        })
        promises.push(promise)
      }

      const changedCategories = this.categories.filter(x=>x.changed && x.id)
      if(changedCategories.length >0){
        const promise = this.$store.dispatch("updateDocumentsCategories", changedCategories)
        promises.push(promise)
      }

      Promise.all(promises).then(async()=>{
        await this.$store.dispatch("getDocuments");
        await this.$store.dispatch("getDocumentsCategories");
        this.close();
      });
    }
  },
  watch:{
    categories(){
      this.allCategories = this.categories
    }
  },
}